import React from 'react'
import { object, bool } from 'prop-types'
import Link from 'react-router/lib/Link'
import Loading from 'bisu-react-loading'
import Panel from 'react-bootstrap/lib/Panel'
import Print from 'react-icons/lib/md/print'
import Excel from 'react-icons/lib/fa/file-excel-o'

import { serialize } from 'utils/helpers'

import SummaryHeader from './summary-header'
import SummaryList from './summary-list'

const Summary = ({ data, pending, downloading, onDownload }) => {
  if (pending) {
    return <Loading />
  }

  if (data.size === 0) {
    return null
  }

  const query = serialize(data.get('header').toJS())

  const header = (
    <div className="row">
      <div className="col-sm-6">Collections Summary</div>
      <div className="col-sm-6 text-right">
        <button type="button" onClick={onDownload} className="btn-icon btn-inline"><Excel /></button>
        <Link to={`/print/reports/collections?${query}`} target="_blank" className="btn-icon btn-inline"><Print /></Link>
      </div>
    </div>
  )

  return (
    <Panel header={header}>
      <SummaryHeader data={data.get('header')} />
      <SummaryList data={data.get('data')} total={data.getIn(['header', 'total'])} />
      {downloading && <Loading text="Processing..." overlay />}
    </Panel>
  )
}

Summary.propTypes = {
  data: object,
  pending: bool,
}

export default Summary



// WEBPACK FOOTER //
// ./src/containers/Reports/Collections/summary.js